import { Type as ClientType, type TypeProps } from './client';

export const Type = (props: TypeProps) => {
  return <ClientType {...props} />;
};
